import React from "react";
import { useForm } from "react-hook-form";
import { MultiDropDownInput } from "../../wrappers/multiselectInput";
import { RadioInput } from "../../wrappers/radioInput";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../../components/button";
import Modal from "../../components/modal";

export type ShareResume = {
  shareType: number;
  links: any;
};

interface Props {
  defaultvalues?: any;
  onClose?: any;
  clickHandler?: any;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
const ShareResume: React.FC<Props> = ({ onClose, clickHandler }) => {
  const validationSchema = Yup.object({});

  const formOptions = {
    resolver: yupResolver(validationSchema),
  };

  const { register, handleSubmit, control, setValue, watch } =
    useForm<ShareResume>(formOptions);

  const handleChange = (e: any, name: string) => {
    setValue("shareType", e.value);
  };

  const onSubmit = (data: any) => {
  };

  return (
    <Modal title={" "} onClose={onClose} size="small">
      <form>
        <h3>Share Resume</h3>
        <div>
          <RadioInput<ShareResume>
            layout={"horizontal"}
            data={[
              { label: "PDF", value: 1 },
              { label: "Link", value: 2 },
            ]}
            handleChange={(e: any) => handleChange(e, "shareType")}
            name="shareType"
            control={control}
          />
              </div>
              <div>
                <h5>Emails you wish to share your resume</h5>
              </div>
        <div>
          <MultiDropDownInput<ShareResume>
            name="links"
            data={[]}
            control={control}
            placeholder="Please enter to add emails"
            register={register}
            disabled={!watch().shareType}
          />
        </div>
        <div className="popupAction">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit(onSubmit)}>
            Send
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ShareResume;
